import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

const examples = [
  {
    label: "Przykład 1. Definicja logarytmu",
    summary: "log₂8 = 3, ponieważ 2³ = 8",
    content: (
      <>
        <BlockMath math="\log_2 8=3\iff 2^3=8" />
        <p>
          Logarytm odpowiada na pytanie: do jakiej potęgi należy podnieść
          podstawę, aby otrzymać argument?
        </p>
      </>
    ),
  },
  {
    label: "Przykład 2. Zamiana liczby na logarytm",
    summary: "2 = log₃9",
    content: (
      <>
        <BlockMath math="2=\log_3 9,\qquad\text{bo}\qquad 3^2=9" />
        <p>
          Ogólnie każdą liczbę <InlineMath math="m" /> możemy zapisać jako:
        </p>
        <BlockMath math="m=\log_a\left(a^m\right)" />
      </>
    ),
  },
  {
    label: "Przykład 3. Suma logarytmów",
    summary: "Suma zamienia się w logarytm iloczynu",
    content: (
      <>
        <BlockMath math="\log_2 4+\log_2 8=\log_2(4\cdot8)=\log_2 32=5" />
        <BlockMath math="\log_a x+\log_a y=\log_a(xy)" />
      </>
    ),
  },
  {
    label: "Przykład 4. Różnica logarytmów",
    summary: "Różnica zamienia się w logarytm ilorazu",
    content: (
      <>
        <BlockMath math="\log_3 18-\log_3 2
          =\log_3\left(\dfrac{18}{2}\right)=\log_3 9=2" />
        <BlockMath math="\log_a x-\log_a y
          =\log_a\left(\dfrac{x}{y}\right)" />
      </>
    ),
  },
  {
    label: "Przykład 5. Współczynnik przed logarytmem",
    summary: "Współczynnik staje się wykładnikiem argumentu",
    content: (
      <>
        <BlockMath math="3\log_2 4=\log_2\left(4^3\right)=\log_2 64=6" />
        <BlockMath math="k\log_a x=\log_a\left(x^k\right)" />
      </>
    ),
  },
  {label:"Uzupełnienie. Zero i wynik ujemny",summary:"Argument mniejszy od 1 przy podstawie większej od 1",content:<><BlockMath math={String.raw`\log_3 1=0,\quad\log_3 3=1,\quad\log_3\frac19=-2`}/><p>Logarytm może być zerem lub liczbą ujemną; dodatni musi być argument, nie wynik.</p></>},
  {label:"Uzupełnienie. Pierwiastek w argumencie lub podstawie",summary:"Zamiana na potęgi tej samej liczby",content:<><BlockMath math={String.raw`\log_8\sqrt[5]2=\log_{2^3}2^{1/5}=\frac1{15}`}/><BlockMath math={String.raw`\log_{\sqrt3}9=\log_{3^{1/2}}3^2=4`}/><p>Jeżeli podstawa i argument są potęgami tej samej dodatniej liczby różnej od 1, dzielimy wykładnik argumentu przez wykładnik podstawy.</p></>},
  {label:"Uzupełnienie. Współczynnik i łączenie logarytmów",summary:"Najpierw wykładnik, potem iloczyn lub iloraz",content:<><BlockMath math={String.raw`\log_3 108-2\log_3 2=\log_3\frac{108}{2^2}=\log_3 27=3`}/><BlockMath math={String.raw`\log_a x+3\log_a y=\log_a(xy^3)`}/><p>Zakładamy dodatnie x i y oraz dopuszczalną podstawę a. Suma logarytmów nie jest logarytmem sumy.</p><BlockMath math={String.raw`2+\log_3 5=\log_3 9+\log_3 5=\log_3 45`}/></>},

];

export default function LogarithmsPreparationTheory() {
  return (
    <TheoryExamplesRunner
      title="Logarytmy — definicja i najważniejsze własności"
      intro={(
        <>
          <p>
            Dla <InlineMath math="a>0" />, <InlineMath math="a\neq1" /> oraz{" "}
            <InlineMath math="b>0" /> definicja logarytmu ma postać:
          </p>
          <BlockMath math="\log_a b=c\iff a^c=b" />
          <p>
            W działaniach pamiętamy o wspólnej podstawie logarytmów. Argumenty x i y w poniższych wzorach są dodatnie. Nie wolno obliczać logarytmu z zera lub liczby ujemnej.
          </p>
          <BlockMath math="\log_a x+\log_a y=\log_a(xy)" />
          <BlockMath math="\log_a x-\log_a y
            =\log_a\left(\dfrac{x}{y}\right)" />
          <BlockMath math="k\log_a x=\log_a\left(x^k\right)" />
          <p>W zadaniach o funkcji logarytmicznej trzeba dodatkowo pamiętać: dla podstawy większej od 1 funkcja rośnie, a dla podstawy między 0 i 1 maleje. Samo obliczanie wartości nadal korzysta z definicji logarytmu.</p>
        </>
      )}
      examples={examples}
    />
  );
}
